import React, { useContext, useState, useEffect, Suspense } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Image } from '@thd-olt-component-react/core-ui';
import { Button } from '@thd-olt-component-react/button';
import './measurement-guide.scss';

const Overlay = React.lazy(() => import(/* webpackChunkName: "overlay" */ '@thd-olt-component-react/overlay')
  .then((module) => ({ default: module.Overlay })));
// eslint-disable-next-line max-len
const OverlayContent = React.lazy(() => import(/* webpackChunkName: "measurement-guide-overlay-content" */ './OverlayContent/OverlayContent')
  .then((module) => ({ default: module.OverlayContent })));

const MeasurementGuide = () => {
  useEffect(() => { LIFE_CYCLE_EVENT_BUS.lifeCycle.trigger('measurement-guide.ready'); }, []);
  const [opened, toggleOpened] = useState(false);
  const {
    channel
  } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const renderOverlay = () => {
    if (typeof window === 'undefined') return null;
    if (!opened) return null;
    return (
      <Suspense fallback={(<div />)}>
        <Overlay onClose={() => toggleOpened(false)} open={opened} closeButton={isMobile}>
          {!isMobile
          && (
            <div className="measurement-guide__overlay-close">
              <button onClick={() => toggleOpened(false)} type="submit">
                <span className="u__bold">Close</span>
                <Image
                  className="measurement-guide__overlay-close-button"
                  src="https://assets.thdstatic.com/images/v1/close-symbol-orange.svg"
                  alt="close"
                  height="1"
                  width="1"
                />
              </button>
            </div>
          )}
          <Suspense fallback={(<div />)}>
            <OverlayContent channel={channel} />
          </Suspense>
        </Overlay>
      </Suspense>
    );
  };
  return (
    <div className="measurement-guide">
      <div className="measurement-guide__wrapper">
        <div className="measurement-guide__text">
          <Image
            className="measurement-guide__icon"
            src="https://assets.thdstatic.com/images/v1/measure-guide-icon.svg"
            alt="icon"
            height="23"
            width="35"
          />
          <div>
            <div className="measurement-guide__text--header u__bold">
              Not sure what rug size?
            </div>
            <div>
              Find the right size for your space
            </div>
          </div>
        </div>
        <div>
          <Button className="measurement-guide__button" onClick={() => toggleOpened(true)} inline dark outline>
            Measuring Guide
          </Button>
        </div>
      </div>
      {renderOverlay()}
    </div>
  );
};

MeasurementGuide.displayName = 'MeasurementGuide';
export { MeasurementGuide };